import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ReportsList from './List';
import ReportDetails from './Details';

export default function ReportsRouter() {
  return (
    <div>
      <Routes>
        <Route path="" element={<ReportsList />} />
        <Route path=":id" element={<ReportDetails />} />
      </Routes>
    </div>
  );
}
